import ApiService from "./ApiService"

export async function getMyDetails () {
    return ApiService.fetchData({
        url: '/users/me?populate=avatar,role,tene_partner_user_info,tene_partner_user_info.tene_partner_roles,tene_partner_user_info.crop_edit_rights',
        method: 'get'
    }) 
}
// **JSR TODO: Delete
// export async function apiGetNotificationCount () {
//     return ApiService.fetchData({
//         url: '/notification/count',
//         method: 'get'
//     })
// }

// export async function apiGetNotificationList () {
//     return ApiService.fetchData({
//         url: '/notification/list',
//         method: 'get'
//     })
// }

// export async function apiGetSearchResult (data) {
//     return ApiService.fetchData({
//         url: '/search/query',
//         method: 'post',
//         data
//     })
// }